const NAMESPACE = 'LIVE_CHECK_DATA';

const SET_TRIP_CHECKOUT_DATA = `${NAMESPACE}/SET_TRIP_CHECKOUT_DATA`;
const SET_TRIP_LIVE_CHECK = `${NAMESPACE}/SET_TRIP_LIVE_CHECK`;
const REMOVE_TRIP_LIVECHECKS = `${NAMESPACE}/REMOVE_TRIP_LIVECHECKS`;

export {
    REMOVE_TRIP_LIVECHECKS,
    SET_TRIP_CHECKOUT_DATA,
    SET_TRIP_LIVE_CHECK,
};

export default NAMESPACE;
